export default __webpack_public_path__ + "static/media/Liberty Bankers Dark.497bcdfa.svg";